import { center } from './map-options'

// export function getFakeMapData() {
//   const data = []

//   for (let index = 0; index < 200; index++) {
//     data.push({
//       position: {
//         lat: center.lat + Math.random() * 7 - 3.5,
//         lng: center.lng + Math.random() * 10 - 5,
//       },
//       category: parseInt(Math.random() * 5),
//       title: 'Commune de Lannion',
//       population: parseInt(Math.random() * 200000) + ' habitants',
//       date: 'Adhérent depuis le 30/09/2015',
//     })
//   }

//   return data
// }

// export const regions = [
//   { label: 'Auvergne-Rhône-Alpes', position: { lat: center.lat + 1, lng: center.lng + .5 } },
//   { label: 'Bourgogne-Franche-Comté', position: { lat: .3, lng: .2 } },
//   { label: 'Bretagne', position: { lat: 48.0894329, lng: -3.0784447 } },
//   { label: 'Centre-Val de Loire', position: { lat: 0, lng: 0 } },
//   { label: 'Grand Est', position: { lat: 0, lng: 0 } },
//   { label: 'Hauts-de-France', position: { lat: 0, lng: 0 } },
//   { label: 'Ile-de-France', position: { lat: 0, lng: 0 } },
//   { label: 'Normandie', position: { lat: 0, lng: 0 } },
//   { label: 'Nouvelle-Aquitaine', position: { lat: 0, lng: 0 } },
//   { label: 'Occitanie', position: { lat: 0, lng: 0 } },
//   { label: 'Pays de la Loire', position: { lat: 0, lng: 0 } },
//   { label: "Provence-Alpes-Côte d'Azur.", position: { lat: 0, lng: 0 } },
// ]

// export const departements = [
//   { label: 'Ain', position: { lat: 1.2, lng: 0 } },
//   { label: 'Aisnes', position: { lat: 0, lng: 0 } },
// ]

export const habitantSvg = `<svg width="30" height="20" enable-background="new 0 0 30 20" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m18.6 6.9c0 2-1.6 3.7-3.7 3.7-2 0-3.7-1.6-3.7-3.7 0-2 1.6-3.7 3.7-3.7s3.7 1.7 3.7 3.7zm1 0c0-2.6-2.1-4.6-4.6-4.6-2.6 0-4.6 2.1-4.6 4.6 0 2.6 2.1 4.6 4.6 4.6 2.5.1 4.6-2 4.6-4.6z"/><path d="m14.9 11.6c3.4 0 6.1 3.3 6.3 7.5h-12.6c.2-4.2 3-7.5 6.3-7.5zm6.8 8.4c.3 0 .5-.2.5-.5 0-4.9-3.3-8.9-7.3-8.9s-7.3 4-7.3 8.9c0 .3.2.5.5.5z"/><path d="m9.6 4.1c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2c.1-1.7 1.5-3.1 3.3-3.1 1.7 0 3.1 1.4 3.1 3.1zm1 0c0-2.3-1.9-4.1-4.1-4.1-2.3 0-4.2 1.9-4.2 4.1 0 2.3 1.8 4.1 4.1 4.1 2.3.1 4.2-1.8 4.2-4.1z"/><path d="m9.1 15.7h-8.6c-.3 0-.5-.2-.5-.5 0-4.4 2.9-7.9 6.5-7.9 2.5 0 4.8 1.8 5.8 4.5.1.2 0 .5-.3.6-.2.1-.5 0-.6-.3-.9-2.4-2.9-3.9-5-3.9-2.9 0-5.3 2.9-5.5 6.5h8.1c.3 0 .5.2.5.5.1.3-.1.5-.4.5z"/><path d="m26.7 4.1c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2c1.8.1 3.2 1.5 3.2 3.2zm1 0c0-2.3-1.8-4.1-4.1-4.1s-4.1 1.9-4.1 4.1c0 2.3 1.8 4.1 4.1 4.1 2.2.1 4.1-1.8 4.1-4.1z"/><path d="m29.5 15.7h-8.8c-.3 0-.5-.2-.5-.4 0-.3.2-.5.4-.5h.1 8.3c-.2-3.6-2.6-6.5-5.5-6.5-2.1 0-4.1 1.6-5 4-.1.2-.4.4-.6.3s-.4-.4-.3-.6c1-2.8 3.3-4.6 5.9-4.6 3.6 0 6.5 3.5 6.5 7.9 0 .2-.2.4-.5.4z"/></g></svg>`

export const adherentSvg = `<svg width="30" height="20" enable-background="new 0 0 30 20" viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m16.5 2.4c1.4 0 2.5 1.2 2.5 2.6v11.5c0 1.4-1.1 2.5-2.6 2.5h-13c-1.3 0-2.4-1.1-2.4-2.5v-11.5c0-1.4 1.1-2.5 2.6-2.5zm3.5 14.1v-11.5c0-1.9-1.6-3.5-3.5-3.5h-13c-1.9 0-3.5 1.6-3.5 3.5v11.5c0 1.9 1.6 3.5 3.5 3.5h13c1.9 0 3.5-1.6 3.5-3.5z"/><path d="m.5 6.2v-1h19v1z"/><path d="m5.1 4.1c-.3 0-.5-.2-.5-.5v-3.1c0-.3.3-.5.5-.5.3 0 .5.2.5.5v3.2c0 .2-.2.4-.5.4z"/><path d="m14.9 4.1c-.3 0-.5-.2-.5-.5v-3.1c0-.3.2-.5.5-.5s.5.2.5.5v3.2c0 .2-.3.4-.5.4z"/><path d="m6.5 10.2c0 .4-.4.8-.9.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.9-.8s.8.4.8.8zm1 0c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8c1-.1 1.8-.8 1.8-1.8z"/><path d="m10.8 10.2c0 .4-.4.8-.9.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.9-.8s.8.4.8.8zm1 0c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8c1-.1 1.8-.8 1.8-1.8z"/><path d="m15.2 10.2c0 .4-.4.8-.9.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.8-.8s.9.3.9.8zm1 0c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.8 1.8 1.8c.9-.1 1.8-.8 1.8-1.8z"/><path d="m5.7 14.3c.5 0 .8.4.8.8 0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8-.1-.5.3-.8.8-.8zm1.8.8c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.7c0 1 .8 1.8 1.8 1.8 1 0 1.8-.8 1.8-1.7z"/><path d="m10.8 15.1c0 .4-.4.8-.9.8-.4 0-.8-.3-.8-.8 0-.4.4-.8.9-.8s.8.3.8.8zm1 0c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8.8 1.7 1.8 1.7 1.8-.8 1.8-1.7z"/><path d="m14.3 14.3c.5 0 .8.4.8.8s-.4.8-.8.8c-.5 0-.8-.4-.8-.8 0-.5.4-.9.8-.8zm0 2.5c1 0 1.8-.8 1.8-1.7 0-1-.8-1.8-1.8-1.8-1 0-1.8.8-1.8 1.7 0 1 .8 1.8 1.8 1.8z"/></g></svg>`

export const regionIds = [
  'ChIJMVd4MymgVA0R99lHx5Y__Ws', // France

  'ChIJsbWPxd9VkUcR_RfRz30ZyLk', // Grand Est
  'ChIJ3-hEGv1T_kcR9ODuTtX6now', // Nouvelle Aquitaine
  'ChIJ_fju9ukE9UcROuOAIn5wRjk', // Auvergne Rhône-Alpes
  'ChIJQ9gRSYyc8kcRhsLspcJ3AVw', // Bourgogne Franche-Comté
  'ChIJr45-rmHKEUgRsCTfNs2lDAE', // Bretagne
  'ChIJiV0INnu55EcRMCUzBdfIDQE', // Centre-Val de Loire
  'ChIJUcXoBNMA2hIRA2HpAeqSbtk', // Corse
  'ChIJF4ymA8Th5UcRcCWLaMOCCwE', // Île-de-France
  'ChIJR21206wDshIRXMk7aLMSs6s', // Occitanie
  'ChIJub25mcD450cR4lI4Zc0AtJA', // Hauts-de-France
  'ChIJh8D4I2y94UcRAuJIEVbx8iY', // Normandie
  'ChIJQQUJqjgXBUgRtkcc2Asrls8', // Pays de la Loire
  'ChIJrVP5ihlothIRp9EWPSaQFrc', // Provence-Alpes-Côte d'Azur

  "ChIJO-S4EIF3eCER-erb7ImOf0o", // La réunion
  "ChIJUX0od1p1DowRqwdKtzc-vuw", // Guadeloupe
  "ChIJDQdmAPmgaowRsOevFxIbAOE", // Martinique
  "ChIJU9f3hVcVEo0RRvQKD-n3J94", // Guyane
  "ChIJ0VcO-0tLbEsREVxs6jdncZw", // st pierre miquelon
  "ChIJu43y3DMOCiIRSyr-lWcXMv8", // mayotte
  "ChIJnej-KlR1DowR5nUq6msRdAE", // st barth
  "ChIJ_U5xCKxvDowRp4huTgqDGbk", // st martin
  "ChIJPUsabgaxyHERGwrSj-wYyRY", // wallis
  "ChIJTddtfNB1GHQREVfDCXp6wJs", // polynesie
  "ChIJyzIaP2niJ2wR7HqT1Y_20PY", // nouvelle calédonie
]

export const departementsIds = [
  "ChIJ6WS-4x1Yi0cRgCW55CqrCAM", // Ain
  "ChIJ29CbGL9S6EcRkCVhgT7xCgM", // Aisne
  "ChIJLwz0cLrb8EcRoCXjy688CQM", // Allier
  "ChIJj00oCCe0zRIR0CWP_aUZCAM", // Alpes-Maritimes
  "ChIJBb8GGrKcyxIRsCWP_aUZCAM", // Alpes-de-Haute-Provence
  "ChIJjSR_qWAR6kcR8CU3mrlfCgM", // Ardennes
  "ChIJVc2eRUbWtBIR4CXjy688CQM", // Ardèche
  "ChIJd48Xh8I9rxIRACY7L5z2BgM", // Ariège
  "ChIJK9zqn1Sf7kcRECY3mrlfCgM", // Aube
  "ChIJo33zOeEpsBIRICZlFiGIBwM", // Aude
  "ChIJJxwIxhNjshIRMCY7L5z2BgM", // Aveyron
  "ChIJ5TPeMOawlkcRsCk3mrlfCgM", // Bas-Rhin
  "ChIJWxNFLN8CthIRQCaP_aUZCAM", // Bouches-du-Rhône
  "ChIJ7c9WzNpBCkgRUCa1T0gUDAM", // Calvados
  "ChIJ1V2sN7Dm90cRYCbjy688CQM", // Cantal
  "ChIJObJ5-RA0_kcRcCbnYJLTBQM", // Charente
  "ChIJ82Od1IwPAUgRgCbnYJLTBQM", // Charente-Maritime
  "ChIJk819RvJz5kcRInnY_j6TIHA", // Cher
  "ChIJSYs5O4Lr9EcRZ1YvbKYqay4", // Circonscription départementale du Rhône
  "ChIJy6wo8D5f-EcRoCbnYJLTBQM", // Corrèze
  "ChIJsY1VVHY92hIRQCeP_aUZCAM", // Corse-du-Sud
  "ChIJ0fUXP5iE-UcR0CbnYJLTBQM", // Creuse
  "ChIJiUlrPWKC7UcRsCYNszTOCQM", // Côte-d'Or
  "ChIJHY3C8Q7iEUgRwCbfNs2lDAM", // Côtes-d'Armor
  "ChIJg2aT8BMVB0gRcCrnYJLTBQM", // Deux-Sèvres
  "ChIJixOodXR6_0cR4CYRSBdlBgM", // Dordogne
  "ChIJIzJvR4OQjUcR8CYNszTOCQM", // Doubs departement
  "ChIJXUlPlKe6yhIRACe55CqrCAM", // Drôme
  "ChIJH3mvlvjP5UcRMCuLaMOCCwM", // Essonne
  "ChIJxyhuotQ_4UcRECe1T0gUDAM", // Eure
  "ChIJozitvHMK5EcRICczBdfIDQM", // Eure-et-Loir
  "ChIJR380f3HMFkgRMCffNs2lDAM", // Finistère
  "ChIJl5MqKOkVtBIRYCdlFiGIBwM", // Gard
  "ChIJJWOZae2FqRIRgCc7L5z2BgM", // Gers
  "ChIJ8wX2tk4uVQ0RkCcRSBdlBgM", // Gironde
  "ChIJUX0od1p1DowRqwdKtzc-vuw", // Guadeloupe
  "ChIJU9f3hVcVEo0RRvQKD-n3J94", // Guyane
  "ChIJ919PNUx_kUcRwCk3mrlfCgM", // Haut-Rhin
  "ChIJZSDEdS6x0BIRUCeP_aUZCAM", // Haute-Corse
  "ChIJ8Y_ojIzSrhIRcCc7L5z2BgM", // Haute-Garonne
  "ChIJZ2H42zT99UcRMCjjy688CQM", // Haute-Loire
  "ChIJe7Gs8mXo7EcRwCg3mrlfCgM", // Haute-Marne
  "ChIJfRdqefQJjEcRICq55CqrCAM", // Haute-Savoie
  "ChIJfWdzkgjtkkcR4CkNszTOCQM", // Haute-Saône
  "ChIJlSTLuMFK-UcR8CrnYJLTBQM", // Haute-Vienne
  "ChIJD9NgVc9ayxIRwCWP_aUZCAM", // Hautes-Alpes
  "ChIJMVyPnI8yqBIRkCk7L5z2BgM", // Hautes-Pyrénées
  "ChIJIX9UJN165kcRQCuLaMOCCwM", // Hauts-de-Seine
  "ChIJ7TGrfiZmsRIRoCdlFiGIBwM", // Hérault
  "ChIJDaUlkkvcDkgRsCffNs2lDAM", // Ille-et-Vilaine
  "ChIJUfVaUf6d-0cRwCczBdfIDQM", // Indre
  "ChIJE3AWTDjZ_EcR0CczBdfIDQM", // Indre-et-Loire
  "ChIJh1d4BM_oikcR4Ce55CqrCAM", // Isère
  "ChIJQxu3PkkijUcR8CcNszTOCQM", // Jura
  "ChIJO-S4EIF3eCER-erb7ImOf0o", // La Réunion
  "ChIJE5-upTcxVA0RACgRSBdlBgM", // Landes
  "ChIJ4053kaCm5EcRECgzBdfIDQM", // Loir-et-Cher
  "ChIJsTbZ_CG99kcRjxVllrp-FjE", // Loire
  //"ChIJ-WSXe92gjkcRLc1smOQd3T8", // Rhône
  "ChIJcf_obOGN9EcR0Cm55CqrCAM", // Rhône
  "ChIJnbJ5rKiOBUgRQCgJHlI3DQM", // Loire-Atlantique
  "ChIJBQbIKJcN5UcRUCgzBdfIDQM", // Loiret
  "ChIJmVv63eLrrBIRYCg7L5z2BgM", // Lot
  "ChIJWQMhD5hXqhIRcCgRSBdlBgM", // Lot-et-Garonne
  "ChIJn-8fITBssxIRgChlFiGIBwM", // Lozère
  "ChIJ0djq2pfWB0gRkCgJHlI3DQM", // Maine-et-Loire
  "ChIJ9zVZBbiLC0gRoCi1T0gUDAM", // Manche
  "ChIJMw82jABe6UcRsCg3mrlfCgM", // Marne
  "ChIJDQdmAPmgaowRsOevFxIbAOE", // Martinique
  "ChIJ0RHQHMSmCUgRXTpodajCIV8", // Mayenne
  "ChIJu43y3DMOCiIRSyr-lWcXMv8", // Mayotte
  "ChIJ2QzP5IHplEcR4Cg3mrlfCgM", // Meurthe-et-Moselle
  "ChIJna44A7QW60cR8Cg3mrlfCgM", // Meuse
  "ChIJicYx27QiEEgRACnfNs2lDAM", // Morbihan
  "ChIJv8tu0pNQlEcRECk3mrlfCgM", // Moselle
  "ChIJK1LHPbXH8UcRICkNszTOCQM", // Nièvre
  "ChIJrXIXuejQwkcRMClhgT7xCgM", // Nord
  "ChIJa7kkjRq050cRQClhgT7xCgM", // Oise
  "ChIJ416f1TgG4kcRUCm1T0gUDAM", // Orne
  "ChIJD7fiBh9u5kcRYJSMaMOCCwQ", // Paris
  "ChIJ9yrxmAsF3UcRYClhgT7xCgM", // Pas-de-Calais
  "ChIJXxh40_cd90cRcCnjy688CQM", // Puy-de-Dôme
  "ChIJ1USNMzngVg0RgCkRSBdlBgM", // Pyrénées-Atlantiques
  "ChIJs3vVe5L9rxIRoCllFiGIBwM", // Pyrénées-Orientales
  "ChIJuxI_om6J4kcRACoJHlI3DQM", // Sarthe
  "ChIJ01Qj_B7Si0cRECq55CqrCAM", // Savoie
  "ChIJU1QBWoCu80cR8CkNszTOCQM", // Saône-et-Loire
  "ChIJMxPYKBzt4EcRQCq1T0gUDAM", // Seine-Maritime
  "ChIJTeBXx8Zs5kcRUCuLaMOCCwM", // Seine-Saint-Denis
  "ChIJa5Z5nApS70cRUCqLaMOCCwM", // Seine-et-Marne
  "ChIJn6rXUTmH50cRgCphgT7xCgM", // Somme
  "ChIJHY7YvzzirRIRkCo7L5z2BgM", // Tarn
  "ChIJH-CzrKkSrBIRoCo7L5z2BgM", // Tarn-et-Garonne
  "ChIJme6LHo0jkkcRICsNszTOCQM", // Territoire de Belfort
  "ChIJw_oQx5r15kcRcCuLaMOCCwM", // Val-d'Oise
  "ChIJaxiZwqcM5kcRYCuLaMOCCwM", // Val-de-Marne
  "ChIJCQMoGM9OyRIRsCqP_aUZCAM", // Var
  "ChIJ4fZyISNyyhIRwCqP_aUZCAM", // Vaucluse
  "ChIJwZ38qxQwBEgR0CoJHlI3DQM", // Vendée
  "ChIJn8o2UZ4HbUcRRluiUYrlwv0", // Vienne
  "ChIJz-4cRTQMk0cRACs3mrlfCgM", // Vosges
  "ChIJ3zf38u9P7kcRECsNszTOCQM", // Yonne
]

export const departements = [
    "Ain",
    "Aisne",
    "Allier",
    "Alpes-de-Haute-Provence",
    "Hautes-Alpes",
    "Alpes-Maritimes",
    "Ardèche",
    "Ardennes",
    "Ariège",
    "Aube",
    "Aude",
    "Aveyron",
    "Bouches-du-Rhône",
    "Calvados",
    "Cantal",
    "Charente",
    "Charente-Maritime",
    "Cher",
    "Corrèze",
    "Corse-du-Sud",
    "Haute-Corse",
    "Côte-d'Or",
    "Côtes-d'Armor",
    "Creuse",
    "Dordogne",
    // "Doubs", // bug remonte rien
    "Doubs département",
    "Drôme",
    "Eure",
    "Eure-et-Loir",
    "Finistère",
    "Gard",
    "Haute-Garonne",
    "Gers",
    "Gironde",
    "Hérault",
    "Ille-et-Vilaine",
    "Indre",
    "Indre-et-Loire",
    "Isère",
    "Jura",
    "Landes",
    "Loir-et-Cher",
    "Loire",
    // "Rhône", // bug, sort le fleuve
    "Rhône département",
    "Haute-Loire",
    "Loire-Atlantique",
    "Loiret",
    "Lot",
    "Lot-et-Garonne",
    "Lozère",
    "Maine-et-Loire",
    "Manche",
    "Marne",
    "Haute-Marne",
    "Mayenne",
    "Meurthe-et-Moselle",
    "Meuse",
    "Morbihan",
    "Moselle",
    "Nièvre",
    "Nord",
    "Oise",
    "Orne",
    "Pas-de-Calais",
    "Puy-de-Dôme",
    "Pyrénées-Atlantiques",
    "Hautes-Pyrénées",
    "Pyrénées-Orientales",
    "Bas-Rhin",
    "Haut-Rhin",
    "Circonscription départementale du Rhône",
    "Haute-Saône",
    "Saône-et-Loire",
    "Sarthe",
    "Savoie",
    "Haute-Savoie",
    "Paris",
    "Seine-Maritime",
    "Seine-et-Marne",
    "Yvelines",
    "Deux-Sèvres",
    "Somme",
    "Tarn",
    "Tarn-et-Garonne",
    "Var",
    "Vaucluse",
    "Vendée",
    "Vienne",
    "Haute-Vienne",
    "Vosges",
    "Yonne",
    "Territoire de Belfort",
    "Essonne",
    "Hauts-de-Seine",
    "Seine-Saint-Denis",
    "Val-de-Marne",
    "Val-d'Oise",
    "Guadeloupe",
    "Martinique",
    "Guyane",
    "La Réunion",
    "Mayotte"
]